import React, { createContext, ReactNode } from 'react'
import { DIContainer } from '@/app/context/DIContext/containers'

const ServiceContext = createContext<typeof DIContainer | undefined>(undefined)

type ContainerProviderProps = {
    children: ReactNode
}

const DIProvider: React.FC<ContainerProviderProps> = ({ children }) => (
    <ServiceContext.Provider value={DIContainer}>
        {children}
    </ServiceContext.Provider>
)

export { ServiceContext, DIProvider }
